import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const propTypes = {
  empty: PropTypes.bool,
};

const defaultProps = {
  empty: false,
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 3),
  },
}));

const CustomPaper = React.forwardRef((props, ref) => <Paper ref={ref} component="form" {...props} />);

const Form = React.forwardRef((props, ref) => {
  const { empty, ...others } = props;
  const classes = useStyles();
  const formProps = empty
    ? {
      component: 'form',
    }
    : {
      classes: { root: classes.root },
      component: CustomPaper,
    };
  return (
    <Grid ref={ref} item {...formProps} {...others} />
  );
});

Form.propTypes = propTypes;

Form.defaultProps = defaultProps;

export default Form;
